// Versão do app - gerado automaticamente
export const APP_VERSION = '5.27'
export const BUILD_DATE = '16/02/2026, 00:09'
